import { connect } from 'react-redux'
import React from 'react'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import EmailButton from '../emailSender/emailButton'
import NoResults from '../noResults'
import styles from './clientTarificationsZoom.scss'
import KeyValue from '../KeyValue'
import Uploader from '../uploader'
import { setOpenedSubmenu } from 'state/actions'
import nesProp from 'nested-property'
import { getTheLanguageCodeByAnyLanguageOnAnyLanguage, trimCharacterFromLeft } from 'lib/helpers'
import MifidButton from '../DSDocuments/mifidButton'
import CreateContract from './clientContractCreate'
import { DS_MODULE_CLIENT_TARIFICATION } from 'state/constants'
import i18n from 'lib/i18n'
import moment from 'moment'

const _ = i18n('clientTarificationsZoom')

@connect((state, props) => {
    const clientAccess = nesProp.get(state, "app.security.actions")
    let canCreateMifid = false
    const selectedTicketDocuments = nesProp.get(state, "clients.initialArguments.selectedTicketDocuments")
    const ticketDocuments = nesProp.get(state, "clients.initialArguments.ticketDocuments")
    const ticketId = nesProp.get(state, "clients.initialArguments.ticketId")
    const emailAttachmentTicketDocuments = nesProp.get(state, "clients.initialArguments.emailAttachmentTicketDocuments")

    let canCreatePrev = clientAccess.filter((item) => (item.actionName === "createPrev" && item.actionAllowed === "true")).length > 0

    clientAccess.map((item, key) => {
        if (item.actionName == 'createmifid') {
            canCreateMifid = item.actionAllowed === "true" ? true : false
        }
    })

    return {
        EmailTemplateRelations: state.app.security.EmailTemplateRelations,
        clientAccess: clientAccess,
        brNr: state.app.brNr,
        clientData: props && props.clientData || {},
        clientId: props && props.clientId || '',
        clientOptionsDict: state.client.clientOptionsDict,
        contractManagerMail: state.contracts.contractManagerMail,
        appLanguage: state.app.lang,
        canCreateMifid: canCreateMifid,
        selectedTicketDocuments,
        ticketDocuments,
        ticketId,
        emailAttachmentTicketDocuments,
        canCreatePrev
    }
})
export default class ClientTarificationsZoom extends React.Component {
    static propTypes = {
        _translationFromOverview: React.PropTypes.object,
        canCreateTarification: React.PropTypes.bool
    }

    constructor(props) {
        super(props)
        this.state = {
            createContractModalIsOpen: false
        }
    }

    /**
     * Event for close claim. Back to list.
     */
    handleClose = () => {
        const { dispatch } = this.props
        dispatch(setOpenedSubmenu(''))
    }

    /**
    * This function return with values for email sender, collected from this module
    * depending on the current data structure.
    */
    collectVariableValues() {
        const { clientData, clientId, tarification, tarificationId, clientOptionsDict } = this.props

        let tarificationBrokerNumber = nesProp.get(tarification, "brokerNumber")
        let emails = nesProp.get(clientData, "detail.emails")
        let clientName = nesProp.get(clientData, "main.name")

        // process email list to be digestible for email sender
        emails = emails.map((item) => ({
            referenceId: clientId,
            label: clientName,
            value: item.email,
            default: (item.default == "true" || item.default == true) ? true : false
        }))

        emails = emails.sort((item, item2) => {
            if (item.default && !item2.default) { return -1 }
            if (!item.default && item2.default) { return 1 }
            if ((item.default && item2.default) || (!item.default && !item2.default)) { return 0 }
        }) || []

        // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
        let clientLanguage = nesProp.get(clientData, "detail.language") || ''
        clientLanguage = getTheLanguageCodeByAnyLanguageOnAnyLanguage(clientLanguage, clientOptionsDict)

        return {
            tarificationNumber: nesProp.get(this.props, 'tarification.tarificationNumber'),

            clientDocuments: nesProp.get(clientData, "clientDocuments"),
            clientDocumentsType: 'client',
            clientDocumentsId: clientId,

            tarificationDocuments: nesProp.get(this.props, "tarification.tarificationDocuments"),
            tarificationDocumentsType: "tarification",
            tarificationDocumentsId: tarificationId,

            clientId: false,
            contractId: false,
            claimId: false,
            tarificationId,
            clientName: clientName,
            clientNumber: nesProp.get(clientData, "main.clientNumber"),
            clientLanguage,
            clientEmails: emails,

            brokerNumber: tarificationBrokerNumber,

            tarificationDetail: tarification,
            clientData: nesProp.get(clientData, "main")
        }
    }

    /**
   * Resets ticket data from store in order to prevent multiple additions to dsWizzard
   */
    resetDataFromStoreOnCancel() {
        const { dispatch, ticketId, tarificationId } = this.props

        //reset aditional data fro tickets
        if (ticketId) {
            dispatch(setOpenedSubmenu(tarificationId, {}))
        }
    }

    render() {
        const { clientAccess, clientId, tarificationId, tarification, dispatch, initializationCompleted,
            canCreateMifid, _translationFromOverview, canCreateTarification, selectedTicketDocuments,
            ticketDocuments, ticketId, emailAttachmentTicketDocuments, canCreatePrev, clientData } = this.props
        const { createContractModalIsOpen } = this.state
        const tarificationNumber = tarification.tarificationNumber
        const team = tarification.team || ''
        const teamName = tarification.teamName || ''

        if (!tarification || !tarificationNumber) {
            return <span>...</span>
        }

        let dateOfRequest = tarification.requestDate
        if (dateOfRequest && moment(dateOfRequest).isValid()) {
            dateOfRequest = moment(dateOfRequest).format("DD-MM-YYYY")
        }

        const createmail = clientAccess &&
            clientAccess.filter((item) => (item.actionName == "createmail" && item.actionAllowed == "true")).length > 0

        /* const columns = tarification && [
            [
                {label: _('tarificationNumber'), value: tarification.tarificationNumber || '-'},
                {label: _('tarificationState'), value: tarification.tarificationState || '-'},
                {label: _('tarificationType'), value: tarification.tarificationType || '-'},
                {label: _('maingroupCode'), value: tarification.maingroupCode || '-'},
                {label: _('subgroupCode'), value: tarification.subgroupCode || '-'},
                {label: _('subgroupDescription'), value: tarification.subgroupDescription || '-'},
            ],
            [
                {label: _('descriptionRisico'), value: tarification.descriptionRisico || '-'},
                {label: _('companies'), value: tarification.companies || '-'},
                {label: _('requestDate'), value: tarification.requestDate || '-'},
                {label: _('brokerNumber'), value: tarification.brokerNumber || '-'},
                {label: _('brokerName'), value: tarification.brokerName || '-'},
            ],
        ] */

        const columns = tarification && [
            [
                { label: _('groupDescriptions'), value: tarification.maingroupDescription + " - " + tarification.subgroupDescription },
                { label: _('companies'), value: tarification.companies || '-' },
                { label: _('descriptionRisico'), value: tarification.descriptionRisico || '-' }
            ],
            [
                { label: _('requestDate'), value: dateOfRequest || '-' },
                { label: _('tarificationState'), value: tarification.tarificationState || '-' },
                { label: _('broker'), value: [tarification.brokerNumber, tarification.brokerName].join(" ") || '-' },
            ],
        ]

        const moduleKeyToSet = nesProp.get(this.props, "EmailTemplateRelations.EmailTemplateModules.clientTarificationDetails.value") || false
        const documents = tarification.tarificationDocuments

        return (
            <div className={styles.clientTarificationsZoomContainer}>
                <div className={styles.mainTitleDiv}>
                    <div className={styles.moduleControls}>
                        <div className={styles.buttonOrganizer} >
                            <div onClick={() => dispatch(setOpenedSubmenu(''))} className={styles.backToList} >
                                {_('backToTarifications')}
                            </div>
                            {createmail &&
                                <EmailButton moduleKeyToSet={moduleKeyToSet} moduleOptions={this.collectVariableValues()} />}

                            {canCreateTarification && <div className={styles.DSWizardButtonWrapper}>
                                <MifidButton
                                    moduleKeyToSet={DS_MODULE_CLIENT_TARIFICATION}
                                    subModuleKeyToSet={DS_MODULE_CLIENT_TARIFICATION}
                                    clientId={clientId}
                                    callBackOnClose={() => this.resetDataFromStoreOnCancel()}
                                    moduleOptions={this.collectVariableValues()}
                                    selectedTicketDocuments={selectedTicketDocuments}
                                    ticketDocuments={ticketDocuments}
                                    ticketId={ticketId}
                                    emailAttachmentTicketDocuments={emailAttachmentTicketDocuments}
                                    tarificationId={tarificationId}
                                    tarificationNumber={tarificationNumber}
                                />
                            </div>
                            }

                            {canCreatePrev &&
                                <div className={styles.createPrevButtonContainer}>
                                    <div
                                        key={"createContractModalOpenerButtonKey"}
                                        onClick={() => {
                                            this.setState({ createContractModalIsOpen: true })
                                        }}
                                        type="button"
                                        className={styles.prevButton}
                                    >
                                        {_('requestForOffer')}
                                    </div>
                                </div>
                            }

                        </div>
                    </div>
                </div>
                {tarification &&
                    <div className={styles.clientOfferZoom}>
                        <div className={styles.moduleSection}>
                            <div className={styles.moduleSectionHeading}>
                                <h2 className={styles.subTitle}>{_('tarificationNumber')} <span>
                                    {trimCharacterFromLeft(tarificationNumber, "0")}
                                </span></h2>
                            </div>
                            <KeyValue array={columns} divider customClass={styles.keyValuePairCorrection} />
                        </div>
                    </div>
                }
                {documents &&
                    <Uploader
                        type="tarification"
                        documents={documents}
                        id={tarificationId}
                        clientId={clientId}
                    />
                }
                <CreateContract
                    modalIsOpen={createContractModalIsOpen}
                    contract={{
                        contractId: '',
                        contractNumber: '',
                        error: '0', //  0 = No error / 1 = Error creating contract
                        errorString: 'This is the error string',
                    }}
                    isPrem={false}
                    closeModal={() => (this.setState({ createContractModalIsOpen: false }))}
                    clientId={clientId}
                    policyHolder={nesProp.get(clientData, "main.name") || ""}
                    tarificationNumber={tarificationNumber}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/clients/clientTarificationsZoom.jsx